module.exports = __webpack_public_path__ + "src/font/woff/be056cc999091c24b1c70e31f37c21b1.woff";